exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#inst-payment-opt > .custom-control.custom-checkbox > label {\n  cursor: default;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d672e0e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/detailPages/invoiceDetailPages/InvoiceDetailCapsule.vue
// module id = 1499
// module chunks = 2